import { formatMoneyPerCountry } from '@spa/shared/utils/money';
export var formatExtraGuestsAmount = function formatExtraGuestsAmount(standardAmount, unitaryAmount, currencyCode, language) {
  var amount = standardAmount || unitaryAmount;
  return !amount || !currencyCode ? '' : formatMoneyPerCountry(amount, currencyCode, language);
};
export var getRequirementsList = function getRequirementsList(requirements, t) {
  var requirementsMap = [{
    condition: requirements.contract,
    text: t('Contract required')
  }, {
    condition: requirements.guarantor,
    text: t('Guarantor required')
  }, {
    condition: requirements.offlineId,
    text: t('Passport or ID')
  }, {
    condition: requirements.occupation,
    text: t('Proof of occupation')
  }];
  return requirementsMap.filter(function (_ref) {
    var condition = _ref.condition;
    return condition;
  }).map(function (_ref2) {
    var text = _ref2.text;
    return text;
  });
};